export default function waterMarker(userInfo: any) {
  // @ts-ignore
  const WaterMark = window.WaterMark;
  if (WaterMark) {
    WaterMark.clear();
    // IP 场景（版权方登录链路 ip-cooperation/accounts/user_info）后端不返回 watermark_options
    // → mark(undefined) 静默失败、页面无水印；兜底用邮箱作为水印文本（对齐 WatermarkOptionDto.text）
    const options = {
      ...(userInfo?.watermark_options ?? {}),
      text: userInfo?.watermark_options?.text || userInfo?.email,
    };
    WaterMark.mark(options);
  }
}
